import { Module } from 'vuex';
import { IdpAccountState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: IdpAccountState = {
    idpAccounts: undefined,
    idpAccountCount: 0,
    idpAccountDetails: {
        idp_account: undefined,
        idp: undefined,
    },
    wkIdpAccounts: undefined,
    wkIdpAccountCount: 0,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    directSearch: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    create: {
        isProcessing: false,
        isCreated: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const idpAccount: Module<IdpAccountState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
